<h4 class="label">{{ props.label }}</h4>
@if (props.description) {
    <p class="description text-subtle">{{ props.description }}</p>
}
<div class="outer-form__wrapper">
    <formly-form [fields]="fields" [form]="formGroup" (modelChange)="modelChange($event)"></formly-form>
</div>
